import React, { useEffect, useState } from "react";
import { Alert, Button, Container } from "reactstrap";
import { Table, Row, Col, Card, CardBody, CardTitle } from "reactstrap";

// Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";

import { useNavigate, useParams } from "react-router-dom";
import DrugService from "Api/Services/DrugService";
import { Link } from "react-router-dom";
import DeleteModal from "components/Common/DeleteModal";
import Paginations from "common/Paginations";
import UserService from "Api/Services/UserService";
import Spinners from "components/Common/Spinner";
import { flatMap } from "lodash";

const AssignedDrugsUser = () => {
    // Meta title
    document.title = "Assign Drugs | infuseone - Admin";
    const imageUrl = `${process.env.REACT_APP_DRUG_IMAGE_API_URL}`;
    const params = useParams();
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [drugs, setDrugs] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState();
    const [selectedDrugIds, setSelectedDrugIds] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const navigate = useNavigate();


    const loadAssigneDrugs = async (page) => {
        setLoading(true);
        try {
            const response = await DrugService.GetDrugIndex(page).json();
            if (response.status) {
                setDrugs(response.data);
                setCurrentPage(response.meta.current_page);
                setTotalPage(response.meta.last_page);
                setLoading(false);
            } else {
                setError(response.message);
            }
        } catch (error) {
            setError('Something went wrong');
        }
    };
    const loadAssignedDrugidlist = async () => {
        setLoading(true);
        try {
            const response = await UserService.AssignedDrugIdlist(params.id).json();
            if (response.status) {
                setSelectedDrugIds(response.data)
                setLoading(false);
            } else {
                setLoading(false);
                setError(response.message);
            }
        } catch (error) {
            setError('Something went wrong');
        }
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
        loadAssigneDrugs(page);
    };

    const handleSelectAllChange = () => {
        if (selectAll) {
            setSelectedDrugIds([]);
        } else {
            const allDrugIds = drugs.map(drug => drug.id);
            setSelectedDrugIds(allDrugIds);
        }
        setSelectAll(!selectAll); // Toggle Select All state
    };
    const handleCheckboxChange = (drugId) => {
        setSelectedDrugIds(prevState => {
            if (prevState.includes(drugId)) {
                return prevState.filter(id => id !== drugId);
            } else {
                return [...prevState, drugId];
            }
        });
    };
    const AssigneDrugIdUser = async () => {
        setLoading(true);
        try {
            const userData = {
                drug_ids: selectedDrugIds
            };
            const response = await UserService.AssigneDrugIdUser(params.id, userData).json();
            if (response.status) {
                setDrugs(response.data);
                setSuccess('Drugs assigned successfully')
                loadAssigneDrugs(1);
                setLoading(false);
            } else {
                setError(response.message);
            }
        } catch (error) {
            setError('Something went wrong');
        }
    };

    useEffect(() => {
        loadAssigneDrugs(currentPage);
        loadAssignedDrugidlist();
    }, []);

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div className="container-fluid">
                        <Breadcrumbs title="Dashboard" breadcrumbItem="Assign Drugs" />
                        <Row>
                            {isLoading ? <Spinners setLoading={setLoading} /> :
                                <Col lg={12}>
                                    <Card className="commonboxform">
                                        <CardBody>
                                            <div className='d-flex justify-content-between  align-items-center'>
                                                <CardTitle className="h4">Assign Drugs</CardTitle>
                                                <div className="d-flex gap-3">
                                                    <Link to="/user-list" className='btn btn-secondary'>Go Back</Link>
                                                    <Link to="" className='btn btn-secondary' onClick={() => AssigneDrugIdUser()}>Assign Drugs</Link>
                                                </div>
                                            </div>
                                            {success && (
                                                <Alert color="success" style={{ marginTop: "13px" }}>
                                                    {success}
                                                </Alert>
                                            )}
                                            <div className="table-responsive">
                                                <Table className="table mb-0">
                                                    <thead>
                                                        <tr>
                                                            <th>
                                                                <div className="form-check form-check-end">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id="defaultCheckAll"
                                                                        checked={selectAll}
                                                                        onClick={handleSelectAllChange}
                                                                    />
                                                                </div>
                                                            </th>
                                                            <th>No</th>
                                                            <th>Name</th>
                                                            <th>Image</th>
                                                            <th>Active</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {drugs?.map((drug, index) => (
                                                            <tr key={drug.id}>
                                                                <td>
                                                                    <div className="form-check form-check-end">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            checked={selectedDrugIds.includes(drug.id)}
                                                                            onClick={() => handleCheckboxChange(drug.id)}
                                                                            id={`drugCheck${drug.id}`}
                                                                        />
                                                                    </div>
                                                                </td>
                                                                <td>{(currentPage - 1) * 10 + index + 1}</td>
                                                                <td>{drug.name}</td>
                                                                <td>
                                                                    <img
                                                                        src={`${imageUrl}/${drug.image}`}
                                                                        alt={drug.name}
                                                                        className="img-fluid"
                                                                        style={{ width: '100px', height: '40px', objectFit: 'cover' }}
                                                                    />
                                                                </td>
                                                                <td>{drug.status == 1 ? 'Yes' : 'No'}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                                <Paginations
                                                    currentPage={currentPage}
                                                    totalPages={totalPage}
                                                    onPageChange={handlePageChange}
                                                />
                                            </div>
                                        </CardBody>
                                    </Card>
                                </Col>
                            }
                        </Row>
                    </div>
                </Container>
            </div>
        </React.Fragment>
    )
};

export default AssignedDrugsUser;